import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseServiceWithFilter } from './base.service';
import { Bank } from '@cl/shared/models';
import { BankFilter } from '@cl/shared/models/banks/bank-filter.model';

@Injectable({ providedIn: 'root' })
export class BanksService extends BaseServiceWithFilter<Bank, BankFilter> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/banks/');
    }
}
